"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../component.js"));

var _ = require("../");

var _datepicker = _interopRequireDefault(require("../datepicker"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
var DateRangePicker = /*#__PURE__*/function (_Component) {
  _inherits(DateRangePicker, _Component);

  var _super = _createSuper(DateRangePicker);

  function DateRangePicker() {
    var _this;

    _classCallCheck(this, DateRangePicker);

    _this = _super.call(this);
    _this.state = {
      start: {
        date: null,
        time: null
      },
      end: {
        date: null,
        time: null
      }
    };
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DateRangePicker, [{
    key: "onClick",
    value: function onClick(e) {}
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);
      var children = this.props.children || [];
      children.length < 1 && children.push( /*#__PURE__*/_react.default.createElement(_datepicker.default, {
        dateLabel: "Start date",
        timeLabel: "Time"
      }));
      children.length < 2 && children.push( /*#__PURE__*/_react.default.createElement(_datepicker.default, {
        dateLabel: "End date",
        timeLabel: "Time"
      }));

      var _React$Children$map = _react.default.Children.map(children, function (picker, index) {
        var props = {
          onChange: function onChange(date, time) {
            return _this2.setState(_defineProperty({}, index ? "end" : "start", {
              date: date,
              time: time
            }));
          }
        };

        if (index === 1) {
          props.minDate = _this2.state.start.date;
        }

        return /*#__PURE__*/_react.default.cloneElement(picker, props);
      }),
          _React$Children$map2 = _slicedToArray(_React$Children$map, 2),
          startDatePicker = _React$Children$map2[0],
          endDatePicker = _React$Children$map2[1];

      var label = this.props.label && /*#__PURE__*/_react.default.createElement(_.Label, null, this.props.label);

      return /*#__PURE__*/_react.default.createElement("div", {
        style: this.getStyle(),
        className: this.getClassNames(),
        tabIndex: 0
      }, label, /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__container"
      }, startDatePicker, /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__separator"
      }, "\u2013"), endDatePicker));
    }
  }]);

  return DateRangePicker;
}(_component.default);
/*---------------------------------------------*/


exports.default = DateRangePicker;

_defineProperty(DateRangePicker, "BASE_CLASS", "lth-c-daterangepicker");

DateRangePicker.METADATA = {
  name: "Daterangepicker",
  props: [{
    name: "label",
    type: "string",
    default: "Enter your input"
  }]
};